import type { LightningProps } from 'owa-lightning-core-v2';
import type { ITeachingBubbleProps } from '@fluentui/react/lib/TeachingBubble';
import type { ICoachmarkProps } from '@fluentui/react/lib/Coachmark';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "LightningV2" */ './lazyIndex'),
    { name: 'LightningV2' }
);

export { lightable } from './components/Lightning';
export const LightableCoachmark: LazyComponent<
    LightningProps &
        ICoachmarkProps & {
            teachingBubbleContentProps: ITeachingBubbleProps;
        },
    any,
    void
> = createLazyComponent(lazyModule, m => m.LightableCoachmark);
